export const ActionTypes = {
  FETCH_JOB_GRID: 'services/dashboards/job/fetch_job_grid',
  SET_JOB_GRID: 'services/dashboards/job/set_job_grid',
  SET_LOADER_STATUS: 'services/dashboards/job/set_loader_status',
  SET_JOB_TOOL_CAVITY_LOADER_STATUS: 'services/dashboards/job/set_job_tool_cavity_loader_status',
  FETCH_UNASSIGNED_JOBS: 'services/dashboards/job/fetch_unassigned_jobs',
  SET_UNASSIGNED_JOBS: 'services/dashboards/job/set_unassigned_jobs',
  FETCH_PACKINGTYPES: 'services/dashboards/job/fetch_packing_types',
  MOVE_JOB: 'services/dashboards/job/move_job',
  MOVE_LINE_JOB: 'services/dashboards/job/move_line_job',
  MOVE_UNASSIGNED_JOB_TO_LINE: 'services/dashboards/job/move_unassigned_job_to_line',
  SET_MACHINE_STATE: 'services/dashboards/job/set_machine_state',
  CHANGE_MACHINE_STATE: 'services/dashboards/job/change_machine_state',
  SET_LINE_MACHINE_STATE: 'services/dashboards/job/set_line_machine_state',
  MODAL_FETCH_PRODUCT_TOOL: 'services/dashboards/job/modal_fetch_product_Tool',
  MODAL_SET_PRODUCT_TOOL: 'services/dashboards/job/modal_set_product_tool',
  SET_PRODUCT_TOOL_LOADER_STATUS: 'services/dashboards/job/set_product_tool_loader_status',
  ADD_OR_UPDATE_JOB: 'services/dashboards/job/add_or_update_job',
  SET_ADD_OR_UPDATE_JOB: 'services/dashboards/job/set_add_or_update_job',
  UPLOAD_JOB_FILES: 'services/dashboards/job/upload_job_files',
  ADD_LINE_JOB: 'services/dashboards/job/add_line_job',
  UPDATE_LINE_JOB: 'services/dashboards/job/update_line_job',
  CHECK_JOB_UPDATE: 'services/dashboards/job/check_job_update',
  FETCH_JOB_TIMING: 'services/dashboards/job/fetch_job_timing',
  SET_JOB_TIMING: 'services/dashboards/job/set_job_timing',
  SET_PACKINGTYPES: 'services/dashboards/job/set_packingtypes',
  SET_JOB_TIMING_LOADER_STATUS: 'services/dashboards/job/set_job_timing_loader_status',
  FETCH_JOB_ACTIVE_MAINTENANCE: 'services/dashboards/job/fetch_job_active_maintenance',
  SET_JOB_ACTIVE_MAINTENANCE: 'services/dashboards/job/set_job_active_maintenance',
  SET_JOB_ACTIVE_MAINTENANCE_LOADER_STATUS: 'services/dashboards/job/set_job_active_maintenance_loader_status',
  MARK_COMPLETE_JOB: 'services/dashboards/job/mark_complete_job',
  MARK_COMPLETE_LINE_JOB: 'services/dashboards/job/mark_complete_line_job',
  DELETE_JOB: 'services/dashboards/job/delete_job',
  FETCH_JOB_DATA_BY_JOB_ID: 'services/dashboards/job/fetch_job_data_by_job_id',
  FETCH_LINE_CONFIG_DATA_BY_LINE_AND_PRODUCT: 'services/dashboards/job/fetch_line_config_data_by_line_and_product',
  SET_LINE_CONFIG_DATA_BY_LINE_ID: 'services/dashboards/job/set_line_config_data_by_line_id',
  FETCH_JOB_CAMERA_PRODUCT_ATTRIBUTES_BY_LINE_AND_PRODUCT:
    'services/dashboards/job/fetch_job_camera_product_attributes_by_line_and_product',
  SET_JOB_CAMERA_PRODUCT_ATTRIBUTES_BY_LINE_AND_PRODUCT:
    'services/dashboards/job/set_job_camera_product_attributes_by_line_and_product',
  VALIDATE_VISION_COMPATIBILITY: 'services/dashboards/job/validate_vision_compatibility',
  FETCH_LINE_JOB_DATA_BY_LINE_JOB_ID: 'services/dashboards/job/fetch_line_job_data_by_line_job_id',
  SET_LINE_JOB_DATA_BY_LINE_JOB_ID: 'services/dashboards/job/set_line_job_data_by_line_job_id',
  SET_JOB_DATA_BY_JOB_ID: 'services/dashboards/job/set_job_data_by_job_id',
  SET_JOB_DATA_BY_JOB_ID_LOADER_STATUS: 'services/dashboards/job/set_job_data_by_job_id_loader_status',
  FETCH_LINE_JOB_TIMING: 'services/dashboards/job/fetch_line_job_timing',
  SET_LINE_CONFIG_LOADER_STATUS: 'services/dashboards/job/set_line_config_loader_status',
  FETCH_PRODUCT_DATA_BY_TOOL_ID: 'services/dashboards/job/fetch_product_data_by_tool_id',
  SET_PRODUCT_DATA_BY_TOOL_ID: 'services/dashboards/job/set_product_data_by_tool_id',
  SET_PRODUCT_DATA_BY_TOOL_ID_LOADER_STATUS: 'services/dashboards/job/set_product_data_by_tool_id_loader_status',
  ADD_UNPLANNED_DOWNTIME: 'services/dashboards/job/add_unplanned_downtime',
  ADD_DOWNTIME: 'services/dashboards/job/add_downtime',
  FETCH_TOOL_CAVITY_TABLE: 'services/dashboards/job/fetch_tool_cavity_table',
  FETCH_TOOL_CAVITY_JOBID: 'services/dashboards/job/fetch_tool_cavity_jobid',
  SET_TOOL_CAVITY_TABLE: 'services/dashboards/job/set_tool_cavity_table',
  INDEFINITE_EXIST: 'services/dashboards/job/indefinite_exist',
  SET_INDEFINITE_EXIST: 'services/dashboards/job/set_indefinite_exist',
  EDIT_TOOL_CAVITY: 'services/dashboards/job/edit_tool_cavity',
  ASSIGN_JOB_LABOUR: 'services/dashboards/job/assign_job_labour',
  FETCH_EXCEL_JOB_FILE: 'services/dashboards/job/fetch_excel_job_file',
  SET_EXCEL_JOB_FILE: 'services/dashboards/job/set_excel_job_file',
  IMPORT_EXCEL_JOB_FILE: 'services/dashboards/job/import_excel_job_file',
  SET_IMPORT_EXCEL_JOB_FILE: 'services/dashboards/job/set_import_excel_job_file',
  SET_EXPORT_EXCEL_JOB_FILE_LOADER_STATUS: 'services/dashboards/job/set_export_excel_job_file_loader_status',
  SET_IMPORT_EXCEL_JOB_FILE_LOADER_STATUS: 'services/dashboards/job/set_import_excel_job_file_loader_status',
  FETCH_EQUIPMENT_JOBS: 'services/dashboards/job/fetch_equipment_jobs',
  SET_EQUIPMENT_JOBS: 'services/dashboards/job/set_equipment_jobs',
  SET_JOB_SCHEDULE_STATE: 'services/dashboards/job/set_job_schedule_state',

  FETCH_JOBS_BY_FACTORY: 'services/dashboards/job/fetch_jobs_by_factory',
  SET_JOBS_BY_FACTORY: 'services/dashboards/job/set_jobs_by_factory',
  FETCH_EQUIPMENT_JOBS_BY_EQUIPID: 'services/dashboards/job/fetch_equipment_jobs_by_id',
  FETCH_COMPLETED_EQUIPMENT_JOBS_BY_EQUIPID: 'services/dashboards/job/fetch_completed_equipment_jobs_by_id',
  SET_ERP_WORK_ORDER_NO_EXIST: 'services/dashboards/job/set_erp_work_order_no_exist',
  FETCH_ERP_WORK_ORDER_NO_EXIST: 'services/dashboards/job/fetch_erp_work_order_no_exist',
  SET_LINE_PRODUCT_CONFIGURATION: 'services/dashboards/job/set_line_product_configuration',
  FETCH_LINE_PRODUCT_CONFIGURATION: 'services/dashboards/job/fetch_line_product_configuration',
  FETCH_FILES_FOR_DOWNLOAD: 'services/dashboards/job/fetch_files_for_download',
  SET_FILES_FOR_DOWNLOAD: 'services/dashboards/job/set_files_for_download',
  DELETE_JOB_DOC_FILES: 'services/dashboards/job/delete_job_doc_files',
  ADD_LINE_REJECTION: 'services/dashboards/job/add_line_rejection',
  ADD_REWORK: 'services/dashboards/job/add_rework',
  SET_ACCUMULATION_LOADER: 'services/dashboards/job/set_accumulation_loader',
  SET_MOVE_UNASSIGNED_JOB: 'services/dashboards/job/set_move_unassigned_job',
  SET_LINE_JOB_PLC_STATUS: 'services/dashboards/job/set_line_Job_plc_status',
  SET_JOB_PLC_STATUS: 'services/dashboards/job/set_Job_plc_status',
  FETCH_JOB_IMAGES: 'services/dashboards/job/fetch_job_images',
  SET_JOB_IMAGES: 'services/dashboards/job/set_job_images',
  FETCH_JOB_IMAGE_TYPES: 'services/dashboards/job/fetch_job_image_types',
  SET_JOB_IMAGE_TYPES: 'services/dashboards/job/set_job_image_types',
  FETCH_JOB_IDS: 'services/dashboards/job/fetch_job_ids',
  SET_JOB_IDS: 'services/dashboards/job/set_job_ids',
  IS_JOB_RECORD_EXIST: 'services/dashboards/job/is_job_record_exist',
  SET_IS_JOB_RECORD_EXIST: 'services/dashboards/job/set_is_job_record_exist',
  FETCH_JOB_BY_EQUIP_ID: 'services/dashboards/job/fetch_job_by_equip_id',
  SET_JOB_BY_EQUIP_ID: 'services/dashboards/job/set_job_by_equip_id',
  FETCH_JOB_BY_LINE_ID: 'services/dashboards/job/fetch_job_by_line_id',
  SET_JOB_BY_LINE_ID: 'services/dashboards/job/set_job_by_line_id',
  FETCH_CAMERA_HEALTH: 'services/dashboards/job/fetch_camera_health',
  SET_CAMERA_HEALTH: 'services/dashboards/job/set_camera_health',
  REFRESH_CAMERA_HEALTH: 'services/dashboards/job/refresh_camera_health',
  SET_CAMERA_HEALTH_REFRESHING: 'services/dashboards/job/set_camera_health_refreshing',
};

const setMoveUnassignedJob = ({ lineJob }) => ({
  lineJob,
  type: ActionTypes.SET_MOVE_UNASSIGNED_JOB,
});

const setJobScheduleModalState = ({ cardData }) => ({
  cardData,
  type: ActionTypes.SET_JOB_SCHEDULE_STATE,
});

const setFilesForDownload = ({ downloadJobDocFile }) => ({
  downloadJobDocFile,
  type: ActionTypes.SET_FILES_FOR_DOWNLOAD,
});

const editToolCavity = ({ toolCavity }) => ({
  toolCavity,
  type: ActionTypes.EDIT_TOOL_CAVITY,
});
const fetchToolCavityTable = () => ({
  type: ActionTypes.FETCH_TOOL_CAVITY_TABLE,
});
const fetchToolCavityByJobId = jobId => ({
  jobId,
  type: ActionTypes.FETCH_TOOL_CAVITY_JOBID,
});
const setToolCavityTable = ({ toolCavityTable }) => ({
  toolCavityTable,
  type: ActionTypes.SET_TOOL_CAVITY_TABLE,
});

const fetchFilesForDownload = ({ rowId, fileName, jobGridParams }) => ({
  rowId,
  fileName,
  jobGridParams,
  type: ActionTypes.FETCH_FILES_FOR_DOWNLOAD,
});

const deleteJobDocFiles = ({ rowId, fileName, jobGridParams, isOperator }) => ({
  rowId,
  fileName,
  jobGridParams,
  isOperator,
  type: ActionTypes.DELETE_JOB_DOC_FILES,
});

const fetchErpWorkOrderNoExist = ({ erpWorkOrderNoParams, funcCallback }) => ({
  erpWorkOrderNoParams,
  funcCallback,
  type: ActionTypes.FETCH_ERP_WORK_ORDER_NO_EXIST,
});

const setErpWorkOrderNoExist = ({ erpWorkOrderNoData }) => ({
  erpWorkOrderNoData,
  type: ActionTypes.SET_ERP_WORK_ORDER_NO_EXIST,
});

const fetchJobGrid = ({ jobGridParams }) => ({
  jobGridParams,
  type: ActionTypes.FETCH_JOB_GRID,
});

const setJobGrid = ({ jobGrid }) => ({
  jobGrid,
  type: ActionTypes.SET_JOB_GRID,
});
const setLoader = ({ showLoader }) => ({
  showLoader,
  type: ActionTypes.SET_LOADER_STATUS,
});
const setJobToolCavityLoader = ({ showJobToolCavityLoader }) => ({
  showJobToolCavityLoader,
  type: ActionTypes.SET_JOB_TOOL_CAVITY_LOADER_STATUS,
});

// ------------------------ Unassigned Jobs
const fetchUnassignedJobs = ({ jobGridParams }) => ({
  jobGridParams,
  type: ActionTypes.FETCH_UNASSIGNED_JOBS,
});

const setUnassignedJobs = ({ unAssignedJobs }) => ({
  unAssignedJobs,
  type: ActionTypes.SET_UNASSIGNED_JOBS,
});

const fetchPackingTypes = () => ({
  type: ActionTypes.FETCH_PACKINGTYPES,
});

//------------------------------Move Jobs
const moveJob = ({ JobMoveParams, jobGridParams, jobType }) => ({
  JobMoveParams,
  jobGridParams,
  jobType,
  type: ActionTypes.MOVE_JOB,
});
const moveUnassignedJobToLine = ({ JobMoveParams, jobGridParams, jobType }) => ({
  JobMoveParams,
  jobGridParams,
  jobType,
  type: ActionTypes.MOVE_UNASSIGNED_JOB_TO_LINE,
});

//------------------------------Move Line Jobs
const moveLineJob = ({ LineJobMoveParams, jobGridParams, jobType }) => ({
  LineJobMoveParams,
  jobGridParams,
  jobType,
  type: ActionTypes.MOVE_LINE_JOB,
});

//------------------------------
const setMachineState = ({ jobStateParams, jobGridParams }) => ({
  jobStateParams,
  jobGridParams,
  type: ActionTypes.SET_MACHINE_STATE,
});

const changeMachineState = ({ jobStateParams, jobGridParams, notNeedPageUpdate, callback }) => ({
  jobStateParams,
  jobGridParams,
  notNeedPageUpdate,
  callback,
  type: ActionTypes.CHANGE_MACHINE_STATE,
});

const setLineMachineState = ({ lineJobStateParams, jobGridParams, callback }) => ({
  lineJobStateParams,
  jobGridParams,
  callback,
  type: ActionTypes.SET_LINE_MACHINE_STATE,
});

//--------------Job Dashboard Modal
//Job Product Tool
const modalFetchProductTool = ({ productParams }) => ({
  productParams,
  type: ActionTypes.MODAL_FETCH_PRODUCT_TOOL,
});

const modalSetProductTool = ({ productTool }) => ({
  productTool,
  type: ActionTypes.MODAL_SET_PRODUCT_TOOL,
});

const setProductToolLoader = ({ productToolLoader }) => ({
  productToolLoader,
  type: ActionTypes.SET_PRODUCT_TOOL_LOADER_STATUS,
});

// Job Add Update
const addorUpdateJob = ({ jobData, actionName, jobGridParams, callback }) => ({
  jobData,
  actionName,
  jobGridParams,
  callback,
  type: ActionTypes.ADD_OR_UPDATE_JOB,
});

const UploadJobFiles = ({ files, jobid }) => ({
  files,
  jobid,
  type: ActionTypes.UPLOAD_JOB_FILES,
});

const setaddUpdateJob = ({ addUpdateJobData }) => ({
  addUpdateJobData,
  type: ActionTypes.SET_ADD_OR_UPDATE_JOB,
});

// Line Job Add
const addLineJob = ({ jobData, actionName, jobGridParams, callback }) => ({
  jobData,
  actionName,
  jobGridParams,
  callback,
  type: ActionTypes.ADD_LINE_JOB,
});

// Get Job camera attributes
const fetchJobCameraProductAttributesByLineAndProduct = ({ lineId, productId }) => ({
  lineId,
  productId,
  type: ActionTypes.FETCH_JOB_CAMERA_PRODUCT_ATTRIBUTES_BY_LINE_AND_PRODUCT,
});

const setJobCameraProductAttributesByLineAndProduct = ({ jobCameraAttributesData }) => ({
  jobCameraAttributesData,
  type: ActionTypes.SET_JOB_CAMERA_PRODUCT_ATTRIBUTES_BY_LINE_AND_PRODUCT,
});

// Line Job Add
const updateLineJob = ({ jobData, actionName, jobGridParams, callback }) => ({
  jobData,
  actionName,
  jobGridParams,
  callback,
  type: ActionTypes.UPDATE_LINE_JOB,
});

const fetchLineJobTiming = ({ lineJobTimingParams }) => ({
  lineJobTimingParams,
  type: ActionTypes.FETCH_LINE_JOB_TIMING,
});

// Job Update check
const updateCheck = ({ updateJob }) => ({
  updateJob,
  type: ActionTypes.CHECK_JOB_UPDATE,
});

//Job Timing Calculations
const fetchJobTiming = ({ jobTimingParams }) => ({
  jobTimingParams,
  type: ActionTypes.FETCH_JOB_TIMING,
});

const setJobTiming = ({ jobTiming }) => ({
  jobTiming,
  type: ActionTypes.SET_JOB_TIMING,
});

const setAllPackingTypes = ({ allPackingTypes }) => ({
  allPackingTypes,
  type: ActionTypes.SET_PACKINGTYPES,
});

const setJobTimingLoader = ({ jobTimingLoader }) => ({
  jobTimingLoader,
  type: ActionTypes.SET_JOB_TIMING_LOADER_STATUS,
});

// Job Active Maintenance
const fetchJobActiveMaintenance = ({ activeMainenanceObj }) => ({
  activeMainenanceObj,
  type: ActionTypes.FETCH_JOB_ACTIVE_MAINTENANCE,
});

const setJobActiveMaintenance = ({ jobActiveMaintenance }) => ({
  jobActiveMaintenance,
  type: ActionTypes.SET_JOB_ACTIVE_MAINTENANCE,
});

const setJobActiveMaintenanceLoader = ({ jobActiveMaintenanceLoader }) => ({
  jobActiveMaintenanceLoader,
  type: ActionTypes.SET_JOB_ACTIVE_MAINTENANCE_LOADER_STATUS,
});

// Job Mark Complete
const markCompleteJob = ({ JobCompleteParams, jobGridParams }) => ({
  JobCompleteParams,
  jobGridParams,
  type: ActionTypes.MARK_COMPLETE_JOB,
});

// Job Mark Complete
const markCompleteLineJob = ({ lineJobId, callback }) => ({
  lineJobId,
  callback,
  type: ActionTypes.MARK_COMPLETE_LINE_JOB,
});

// Job Delete
const deleteJob = ({ jobId, jobGridParams }) => ({
  jobId,
  jobGridParams,
  type: ActionTypes.DELETE_JOB,
});

// Get Job by Id
const fetchLineConfigByLineAndProduct = ({ lineId, productId }) => ({
  lineId,
  productId,
  type: ActionTypes.FETCH_LINE_CONFIG_DATA_BY_LINE_AND_PRODUCT,
});

// Get Job by Id
const fetchJobByID = ({ jobId }) => ({
  jobId,
  type: ActionTypes.FETCH_JOB_DATA_BY_JOB_ID,
});

// Get Job by Id
const fetchLineJobByID = ({ lineJobId, callback }) => ({
  lineJobId,
  callback,
  type: ActionTypes.FETCH_LINE_JOB_DATA_BY_LINE_JOB_ID,
});

const setJobByID = ({ updateJobData }) => ({
  updateJobData,
  type: ActionTypes.SET_JOB_DATA_BY_JOB_ID,
});

const setLineConfigByLineId = ({ lineConfigData }) => ({
  lineConfigData,
  type: ActionTypes.SET_LINE_CONFIG_DATA_BY_LINE_ID,
});

const setLineJobByID = ({ updateLineJobData }) => ({
  updateLineJobData,
  type: ActionTypes.SET_LINE_JOB_DATA_BY_LINE_JOB_ID,
});

const setJobByIDLoader = ({ jobIdLoader }) => ({
  jobIdLoader,
  type: ActionTypes.SET_JOB_DATA_BY_JOB_ID_LOADER_STATUS,
});

const setlineConfigLoader = ({ lineConfigLoader }) => ({
  lineConfigLoader,
  type: ActionTypes.SET_LINE_CONFIG_LOADER_STATUS,
});

// Get Jobs by Equipment Id
const fetchEquipmentJobs = ({ equipmentJobParams }) => ({
  equipmentJobParams,
  type: ActionTypes.FETCH_EQUIPMENT_JOBS,
});

const fetchEquipmentJobsByEquipId = ({ equipmentId }) => ({
  equipmentId,
  type: ActionTypes.FETCH_EQUIPMENT_JOBS_BY_EQUIPID,
});

const fetchCompletedEquipmentJobsByEquipId = ({ equipmentId }) => ({
  equipmentId,
  type: ActionTypes.FETCH_COMPLETED_EQUIPMENT_JOBS_BY_EQUIPID,
});

const setEquipmentJobs = ({ equipmentJobsData }) => ({
  equipmentJobsData,
  type: ActionTypes.SET_EQUIPMENT_JOBS,
});

// Get Product by Tool Id
const fetchProductsByToolId = ({ toolData }) => ({
  toolData,
  type: ActionTypes.FETCH_PRODUCT_DATA_BY_TOOL_ID,
});

const setProductsByToolId = ({ productsData }) => ({
  productsData,
  type: ActionTypes.SET_PRODUCT_DATA_BY_TOOL_ID,
});

const setProductsByToolIdLoader = ({ productsByToolIdLoader }) => ({
  productsByToolIdLoader,
  type: ActionTypes.SET_PRODUCT_DATA_BY_TOOL_ID_LOADER_STATUS,
});

// Add Unplanned Downtime
const addUnplannedDowntime = ({ downtimeData, toolID, jobData, actionName, jobGridParams }) => ({
  downtimeData,
  toolID,
  jobData,
  actionName,
  jobGridParams,
  type: ActionTypes.ADD_UNPLANNED_DOWNTIME,
});

const addDowntime = ({ newDowntime }) => ({
  newDowntime,
  type: ActionTypes.ADD_DOWNTIME,
});

const addLineRejection = ({ lineRejectionData, callback }) => ({
  lineRejectionData,
  callback,
  type: ActionTypes.ADD_LINE_REJECTION,
});
const addRework = ({ reworkData, callback }) => ({
  reworkData,
  callback,
  type: ActionTypes.ADD_REWORK,
});

const indefiniteExist = ({ equipmentId }) => ({
  equipmentId,
  type: ActionTypes.INDEFINITE_EXIST,
});

const setIndefiniteExist = ({ exist }) => ({
  exist,
  type: ActionTypes.SET_INDEFINITE_EXIST,
});

const assignJobLabour = ({ operator, jobGridParams }) => ({
  operator,
  jobGridParams,
  type: ActionTypes.ASSIGN_JOB_LABOUR,
});

const fetchExcelJobFile = ({ exportFileParams }) => ({
  exportFileParams,
  type: ActionTypes.FETCH_EXCEL_JOB_FILE,
});
const setExcelJobFile = ({ exportJobFile }) => ({
  exportJobFile,
  type: ActionTypes.SET_EXCEL_JOB_FILE,
});
const importExcelJobFile = ({ importFileParams }) => ({
  importFileParams,
  type: ActionTypes.IMPORT_EXCEL_JOB_FILE,
});
const setImportExcelJobFile = ({ importJobFile }) => ({
  importJobFile,
  type: ActionTypes.SET_IMPORT_EXCEL_JOB_FILE,
});
const setExportExcelJobFileLoader = ({ exportExcelFileLoader }) => ({
  exportExcelFileLoader,
  type: ActionTypes.SET_EXPORT_EXCEL_JOB_FILE_LOADER_STATUS,
});
const setImportExcelJobFileLoader = ({ importExcelFileLoader }) => ({
  importExcelFileLoader,
  type: ActionTypes.SET_IMPORT_EXCEL_JOB_FILE_LOADER_STATUS,
});

const fetchJobsByFactory = ({ factoryId }) => ({
  factoryId,
  type: ActionTypes.FETCH_JOBS_BY_FACTORY,
});

const setJobsByFactory = ({ factoryJobs }) => ({
  factoryJobs,
  type: ActionTypes.SET_JOBS_BY_FACTORY,
});

const setLineProductConfiguration = ({ lineConfigurationData }) => ({
  lineConfigurationData,
  type: ActionTypes.SET_LINE_PRODUCT_CONFIGURATION,
});

const setAccumulationLoader = ({ showLoader }) => ({ showLoader, type: ActionTypes.SET_ACCUMULATION_LOADER });
const setLineJobPlcStatus = ({ lineJobPlcParams, jobGridParams }) => ({
  lineJobPlcParams,
  jobGridParams,
  type: ActionTypes.SET_LINE_JOB_PLC_STATUS,
});

const setJobPlcStatus = (jobPlcParams, jobGridParams) => ({
  jobPlcParams,
  jobGridParams,
  type: ActionTypes.SET_JOB_PLC_STATUS,
});

const fetchJobImages = ({ jobId, imageType, jobImagesParams, dateFrom, dateTo, status }) => ({
  jobId,
  imageType,
  jobImagesParams,
  dateFrom,
  dateTo,
  status,
  type: ActionTypes.FETCH_JOB_IMAGES,
});
const setJobImages = ({ jobImages }) => ({
  jobImages,
  type: ActionTypes.SET_JOB_IMAGES,
});
const fetchJobImageTypes = () => ({
  type: ActionTypes.FETCH_JOB_IMAGE_TYPES,
});
const setJobImageTypes = ({ jobImageTypes }) => ({
  jobImageTypes,
  type: ActionTypes.SET_JOB_IMAGE_TYPES,
});

const fetchJobIds = ({ id, isLine }) => ({
  id,
  isLine,
  type: ActionTypes.FETCH_JOB_IDS,
});

const setJobIds = ({ jobIdsData }) => ({
  jobIdsData,
  type: ActionTypes.SET_JOB_IDS,
});

const isJobRecordExist = ({ jobId }) => ({
  jobId,
  type: ActionTypes.IS_JOB_RECORD_EXIST,
});

const setIsJobRecordExist = ({ isJobRecordExist }) => ({
  isJobRecordExist,
  type: ActionTypes.SET_IS_JOB_RECORD_EXIST,
});

const fetchJobByEquipId = ({ equipId }) => ({
  equipId,
  type: ActionTypes.FETCH_JOB_BY_EQUIP_ID,
});

const setJobByEquipId = ({ jobByEquipId }) => ({
  jobByEquipId,
  type: ActionTypes.SET_JOB_BY_EQUIP_ID,
});

const fetchJobByLineId = ({ lineId }) => ({
  lineId,
  type: ActionTypes.FETCH_JOB_BY_LINE_ID,
});

const setJobByLineId = ({ jobByLineId }) => ({
  jobByLineId,
  type: ActionTypes.SET_JOB_BY_LINE_ID,
});

const validateVisionCompatibility = ({ targetLineId, jobId, callback }) => ({
  targetLineId,
  jobId,
  callback,
  type: ActionTypes.VALIDATE_VISION_COMPATIBILITY,
});

const fetchCameraHealth = ({ factoryId }) => ({
  factoryId,
  type: ActionTypes.FETCH_CAMERA_HEALTH,
});

const setCameraHealth = ({ cameraHealthData }) => ({
  cameraHealthData,
  type: ActionTypes.SET_CAMERA_HEALTH,
});

const refreshCameraHealth = ({ lineId, equipmentId }) => ({
  lineId,
  equipmentId,
  type: ActionTypes.REFRESH_CAMERA_HEALTH,
});

const setCameraHealthRefreshing = ({ refreshingCameras }) => ({
  refreshingCameras,
  type: ActionTypes.SET_CAMERA_HEALTH_REFRESHING,
});

export default {
  setMoveUnassignedJob,
  deleteJobDocFiles,
  fetchFilesForDownload,
  setFilesForDownload,
  fetchErpWorkOrderNoExist,
  setErpWorkOrderNoExist,
  fetchJobGrid,
  setJobGrid,
  setLoader,
  setJobToolCavityLoader,
  fetchUnassignedJobs,
  setUnassignedJobs,
  fetchPackingTypes,
  setAllPackingTypes,
  moveJob,
  setJobScheduleModalState,
  moveLineJob,
  changeMachineState,
  setMachineState,
  setLineMachineState,
  modalFetchProductTool,
  modalSetProductTool,
  setProductToolLoader,
  addorUpdateJob,
  UploadJobFiles,
  setaddUpdateJob,
  addLineJob,
  updateLineJob,
  updateCheck,
  fetchJobTiming,
  fetchLineJobTiming,
  setJobTiming,
  setJobTimingLoader,
  fetchJobActiveMaintenance,
  editToolCavity,
  fetchToolCavityTable,
  fetchToolCavityByJobId,
  setToolCavityTable,
  setJobActiveMaintenance,
  setJobActiveMaintenanceLoader,
  markCompleteJob,
  markCompleteLineJob,
  deleteJob,
  fetchJobByID,
  fetchLineConfigByLineAndProduct,
  fetchJobCameraProductAttributesByLineAndProduct,
  setJobCameraProductAttributesByLineAndProduct,
  setLineConfigByLineId,
  fetchLineJobByID,
  setJobByID,
  setLineJobByID,
  setJobByIDLoader,
  setlineConfigLoader,
  fetchEquipmentJobs,
  fetchEquipmentJobsByEquipId,
  fetchCompletedEquipmentJobsByEquipId,
  setEquipmentJobs,
  fetchProductsByToolId,
  setProductsByToolId,
  setProductsByToolIdLoader,
  addUnplannedDowntime,
  addDowntime,
  indefiniteExist,
  setIndefiniteExist,
  assignJobLabour,
  fetchExcelJobFile,
  setExcelJobFile,
  importExcelJobFile,
  setImportExcelJobFile,
  setExportExcelJobFileLoader,
  setImportExcelJobFileLoader,
  fetchJobsByFactory,
  setJobsByFactory,
  setLineProductConfiguration,
  moveUnassignedJobToLine,
  addLineRejection,
  addRework,
  setAccumulationLoader,
  setLineJobPlcStatus,
  setJobPlcStatus,
  fetchJobImages,
  setJobImages,
  fetchJobImageTypes,
  setJobImageTypes,
  fetchJobIds,
  setJobIds,
  isJobRecordExist,
  setIsJobRecordExist,
  fetchJobByEquipId,
  setJobByEquipId,
  fetchJobByLineId,
  setJobByLineId,
  validateVisionCompatibility,
  fetchCameraHealth,
  setCameraHealth,
  refreshCameraHealth,
  setCameraHealthRefreshing,
};
